<template>
  <div class="edit-text-input-cell-renderer">
    <InputBox ref="Input" class="edit-text-input-cell-renderer__input" v-model="value" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ICellRendererParams } from 'ag-grid-community';

export default defineComponent({
  name: 'EditCommentCellRenderer',

  props: {
    params: {
      type: Object as PropType<ICellRendererParams<any, string>>,
      required: true,
    },
  },

  mounted() {
    this.$el.addEventListener('click', this.handleClick);
    this.value = this.params.value;
    // Timeout is necessary to make sure the input is focused after the cell is rendered
    setTimeout(() => {
      this.$refs.Input.focus();
    }, 0);
  },
  beforeUnmount() {
    this.$el.removeEventListener('click', this.handleClick);
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    handleClick(event: MouseEvent) {
      event.stopPropagation();
    },
    /**
     * @public
     */
    getValue() {
      return this.value;
    },
  },
});
</script>

<style lang="scss">
.edit-text-input-cell-renderer {
  width: 440px;
}
.edit-text-input-cell-renderer__input {
  width: 100%;

  & .input-box__wrapper {
    height: auto;

    & input {
      padding: 16px;
    }
  }
}
</style>
